import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Heading from 'components/atoms/Heading';
import Paragraph from 'components/atoms/Paragraph';
import { database } from 'helpers/firebase';

const Container = styled.div`
  width: 100%;
  padding: 15px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-template-rows: 1fr 1fr 1fr 1fr 1fr;
  gap: 25px 25px;
  grid-template-areas:
    'users users logs logs'
    'users users logs logs'
    'users users logs logs'
    'users users logs logs';
`;

const Box = styled.div`
  display: flex;
  flex-flow: column nowrap;
  padding: 15px;
  border-radius: 15px;
  border: 2px solid ${({ theme }) => theme.gray5};
`;

const Password = styled(Box)`
`;

const Users = styled(Box)`
  grid-area: users;
`;

const Logs = styled(Box)`
  grid-area: logs;
`;

const Title = styled(Heading)``;

const Input = styled.input`
  background-color: transparent;
  font-size: 55px;
  color: ${({ theme }) => theme.text};
  outline: none;
  border: 2px solid transparent;
  border-radius: 10px;
  padding: 10px;
  font-weight: 500;
  font-family: 'Poppins', sans-serif;

  :hover {
    border-color: ${({ theme }) => theme.gray5};
  }
`;

const StyledButton = styled.button`
  padding: 4px 8px;
  background-color: ${({ theme, remove }) => (remove ? theme.red : theme.blue)};
  border: none;
  border-radius: 10px;
  color: ${({ theme }) => theme.text};
  font-size: ${({ theme }) => theme.body};
  font-family: 'Poppins', sans-serif;
  cursor: pointer;
  margin-top: 10px;
  outline: none;
  transition: background-color 0.15s ease-in-out;

  :hover,
  :focus {
    background-color: ${({ theme, remove }) => (remove ? theme.redHover : theme.blueHover)};
  }

  :disabled {
    opacity: 0.38;
    cursor: default;
  }
`;

const List = styled.ul`
  list-style: none;
  display: flex;
  flex-flow: column nowrap;
  height: 100%;
  width: 100%;
`;

const Item = styled.li`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-between;
  height: 32px;
  width: 100%;
  padding: 5px 10px;
  border: 1px solid ${({ theme }) => theme.gray5};
  border-radius: 5px;
`;

function timeSince(date) {
  const seconds = Math.floor((new Date() - new Date(date)) / 1000);
  let interval = seconds / 86400;
  if (interval > 1) {
    return `${Math.floor(interval)} dni temu`;
  }
  interval = seconds / 3600;
  if (interval > 1) {
    return `${Math.floor(interval)} godz temu`;
  }
  interval = seconds / 60;
  if (interval > 1) {
    return `${Math.floor(interval)} min temu`;
  }
  if (seconds === 0) {
    return 'online';
  }
  return `${Math.floor(seconds)} sek temu`;
}

function Admin({ isAdmin }) {
  const [password, setPassword] = useState('');
  const [users, setUsers] = useState([]);

  useEffect(() => {
    database.ref('other/password').on('value', (snapshot) => {
      setPassword(snapshot.val());
    });

    database.ref(`other/users`).on('value', (snapshot) => {
      const arr = [];
      snapshot.forEach((snap) => {
        arr.push({ ...snap.val(), key: snap.key });
      });

      setUsers(arr);
    });
  }, []);

  const handleChange = (e) => {
    setPassword(e.target.value);
  };

  const handleSetPassword = () => {
    database.ref('other').update({ password });
  };

  const handleKick = (key) => {
    database.ref(`other/users/${key}`).update({ isKick: true });
  };

  const handleRemove = (key) => {
    database.ref(`other/users/${key}`).remove();
  };

  return isAdmin ? (
    <>
    <Password>
      <Title secondary>Obecne hasło</Title>
      <Input type="text" value={password} onChange={handleChange} />
      <StyledButton type="button" onClick={handleSetPassword}>
        <Paragraph>Zapisz</Paragraph>
      </StyledButton>
    </Password>
    <Container>
      <Users>
        <Title secondary>Użytkownicy</Title>
        <List>
          {users
            .sort((a, b) => b.lastLogin - a.lastLogin)
            .map((user) => (
              <Item>
                <Paragraph>{user.name ? `${user.name} [${user.ip}]` : user.ip}</Paragraph>
                <button type="button" onClick={() => handleRemove(user.key)}>
                  X
                </button>
                <button type="button" onClick={() => handleKick(user.key)}>
                  Kick
                </button>
                <Paragraph>{timeSince(user.lastLogin)}</Paragraph>
              </Item>
            ))}
        </List>
      </Users>
      <Logs>
        <Title secondary>Logi</Title>
      </Logs>
    </Container>
    </>
  ) : null;
}

Admin.propTypes = {
  isAdmin: PropTypes.bool,
};

Admin.defaultProps = {
  isAdmin: false,
};

export default Admin;
